<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs
      v-if="userData"
      pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Data Detail</span>
        </template>
        <user-edit-tab-account
          :user-data="userData"
          :disable-btn="disableBtn"
          class="mt-2 pt-75"
          @submit-form="submitForm"
        />
      </b-tab>

      <!-- Tab: Information -->
      <!--      <b-tab>-->
      <!--        <template #title>-->
      <!--          <feather-icon-->
      <!--            icon="InfoIcon"-->
      <!--            size="16"-->
      <!--            class="mr-0 mr-sm-50"-->
      <!--          />-->
      <!--          <span class="d-none d-sm-inline">Information</span>-->
      <!--        </template>-->
      <!--        <user-edit-tab-information class="mt-2 pt-75" />-->
      <!--      </b-tab>-->

      <!-- Tab: Social -->
      <!--      <b-tab>-->
      <!--        <template #title>-->
      <!--          <feather-icon-->
      <!--            icon="Share2Icon"-->
      <!--            size="16"-->
      <!--            class="mr-0 mr-sm-50"-->
      <!--          />-->
      <!--          <span class="d-none d-sm-inline">Social</span>-->
      <!--        </template>-->
      <!--        <user-edit-tab-social class="mt-2 pt-75" />-->
      <!--      </b-tab>-->
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import userStoreModule from '../userStoreModule'
import UserEditTabAccount from './UserEditTabAccount.vue'
import UserEditTabInformation from './UserEditTabInformation.vue'
// import UserEditTabSocial from './UserEditTabSocial.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    UserEditTabAccount,
    UserEditTabInformation,
    // UserEditTabSocial,
  },
  setup() {
    const userData = ref(null)
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const disableBtn = ref(false)

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    // GET USER DATA
    store.dispatch('app-user/getUser', { id: router.currentRoute.params.id })
      .then(response => {
        userData.value = response.data.data
        if (userData.status === 1){
          userData.status = true
        }
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    const submitForm = () => {
      disableBtn.value = true
      store.dispatch('app-user/updateUser', {
        id: router.currentRoute.params.id,
        data: userData.value,
      })
        .then(response => {
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success!',
              icon: 'CheckIcon',
              variant: 'success',
              text: response.data.message,
            },
          })
          disableBtn.value = false
          router.push({ name: 'user-setting' })
        })
        .catch(error => {
          if (error.response !== undefined){
            toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${error.response.status} Error has occured`,
                icon: 'XIcon',
                variant: 'danger',
                text: error.response.data.message,
              },
            })
            disableBtn.value = false
          }
        })
    }

    return {
      disableBtn,
      userData,
      submitForm,
    }
  },
}
</script>

<style>

</style>
